<template>
  <section class="housemaid-policy-form flex-1">
    <lazy-dom>
      <el-form
        ref="form"
        :rules="formRules"
        :disabled="showBuyable"
        :model="formData">
        <div
          v-if="isCancel"
          class="box">
          <h3></h3>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Cancellation Effective Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                :prop="checkRefer===1?'':'pcy_expry_dt'">
                <v-date-picker
                  v-model="formData.pcy_expry_dt"
                />
              </el-form-item>

            </div>
          </div>
        </div>
        <div class="box">
          <h2>Policy Details</h2>
          <div
            v-if="!isCancel"
            class="flex-sb">
            <div class="form-item form-half">
              <span>{{ isEndorsement? 'Endorsement Effective Date': 'Expected Effective Date' }}</span>
              <el-form-item
                ref="pcy_cmnt_dt"
                :prop="checkRefer===1?'':'pcy_cmnt_dt'">
                <v-date-picker
                  v-model="formData.pcy_cmnt_dt"
                  :_45daysComfirm='true'
                />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="!isCancel"
            class="form-item form-half">
            <span>Expected Expiry Date </span>
            <el-form-item
            >
              <v-date-picker
                :value="endDate"
                disabled/>
            </el-form-item>
          </div>
        </div>
        <div
          v-if="isRefer&&insuredItems.length>0"
          class="box">
          <h3>Insured Items</h3>
          <div class="form-item option_checkout">
            <v-checkbox-group
              v-model="formData.benefits"
              :isColumn="false"
              :list="insuredItems" />
          </div>
        </div>
        <!--        <div-->
        <!--          v-if="benefitList.length>0&&!isRefer"-->
        <!--          class="box">-->
        <!--          &lt;!&ndash;          <h2>Insured Items</h2>&ndash;&gt;-->
        <!--          <div-->
        <!--            class="form-item form-half option_checkout">-->
        <!--            <span>Insured Items</span>-->
        <!--            <el-form-item-->
        <!--            >-->
        <!--              <v-checkbox-group-->
        <!--                v-model="formData.benefits"-->
        <!--                :list="benefitList"-->
        <!--                :isColumn="false"-->
        <!--                @change="handlerExtra"-->
        <!--              />-->
        <!--            </el-form-item>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="box">
          <h2>Policyholder Details</h2>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Title</span>
              <el-form-item
                ref="isrd_title"
                prop="isrd_title">
                <v-select
                  v-model="formData.isrd_title"
                  :list="titleOptions"
                  :disabled="isCancel||checkDisabled('isrd_title')"
                />
              </el-form-item>
            </div>
          </div>
          <div class="form-item form-half">
            <span>Last Name</span>
            <el-form-item
              ref="isrd_lst_nm"
              prop="isrd_lst_nm">
              <v-input
                v-model="formData.isrd_lst_nm"
                uppercase
                :disabled="isCancel||checkDisabled('isrd_lst_nm')"
                @change="changeInsured"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>First Name</span>
            <el-form-item
              ref="isrd_fst_nm"
              prop="isrd_fst_nm">
              <v-input
                v-model="formData.isrd_fst_nm"
                uppercase
                :disabled="isCancel||checkDisabled('isrd_fst_nm')"
                @change="changeInsured"/>
            </el-form-item>
          </div>
          <div class="flex-sb">

            <div class="form-half">
              <div class="form-item">
                <span>{{formData.id_type==2?'Passport':'HKID'}} Number</span>
                <el-form-item
                  ref="id_type"
                >
                  <v-radio-group
                    v-model="formData.id_type"
                    :disabled="isCancel||checkDisabled('id_type')"
                    :list="personalIdTypOptions"
                    @change="changeInsured" />
                </el-form-item>
                <el-form-item
                  v-if="formData.id_type==1"
                  ref="id_no"
                >
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    placeholder="A123456(3), please input A1234563"
                    :disabled="isCancel||checkDisabled('id_no')"
                    class="mg-t-5"
                    @change="changeInsured" />
                </el-form-item>
                <el-form-item
                  v-else
                  ref="id_no"
                >
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    :disabled="isCancel||checkDisabled('id_no')"
                    class="mg-t-5" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Date of Birth</span>
                <el-form-item prop="isrd_dob">
                  <v-birth-day
                    v-model="formData.isrd_dob"
                    :disabled="isCancel||checkDisabled('isrd_dob')"
                    @change="changeInsured"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="form-item form-half">
            <span>Email</span>
            <el-form-item
              ref="email"
              :rules="rules.email"
              prop="email">
              <v-input
                v-model="formData.email"
                :disabled="isCancel||checkDisabled('email')"/>
            </el-form-item>
          </div>
          <div class="flex-sb">

            <div class="form-item form-half">
              <span>Mobile Number</span>
              <el-form-item
                ref="mobile_no"
                prop="mobile_no">
                <v-input
                  v-model="formData.mobile_no"
                  :disabled="isCancel||checkDisabled('mobile_no')"
                  type="number"/>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="form-half">
          <span class="title">Correspondence Address</span>
          <address-form
            ref="address-form"
            :formType="1"
            :formDataLock="formDataLock"
            :form="addressForm"
            :notValid="checkRefer===2?false:true"
            :disabled="isCancel||showBuyable"
            @getFormData="getAddressForm" />
        </div>


        <div class="pet-box">
          <span class="color-dark pet-title">Pet Details</span>
          <div class="insured-container">
            <div
              v-for="(item, index) in pet_info"
              :key="index"
              class="pet-card"
            >
              <div class="form-item">
                <v-checkbox
                  v-model="checked"
                  disabled>Pet {{ index+1 }}
                </v-checkbox>
              </div>
              <div class="form-item">
                <span>Species</span>
                <el-form-item
                  :ref="`pet_info.${index}.type_of_pet`"
                  :rules="rules.select"
                  :prop="`pet_info.${index}.type_of_pet`"
                >
                  <v-radio-group
                    v-model="item.type_of_pet"
                    block
                    :list="localAllOptions.type_of_pet"
                    disabled
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Name of the Pet</span>
                <el-form-item
                  :ref="`pet_info.${index}.name`"
                  :rules="extraRules.pet_input"
                  :prop="`pet_info.${index}.name`"
                >
                  <v-input
                    v-model="item.name"
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Breed</span>
                <el-form-item
                  :ref="`pet_info.${index}.breed_id`"
                  :rules="rules.select"
                  :prop="`pet_info.${index}.breed_id`">
                  <v-select
                    v-model="item.breed_id"
                    :list="breedList(item.type_of_pet)"
                    disabled
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Colour/Marking</span>
                <el-form-item
                  :ref="`pet_info.${index}.colour_marking`"
                  :rules="extraRules.pet_input"
                  :prop="`pet_info.${index}.colour_marking`"
                >
                  <v-input
                    v-model="item.colour_marking"
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Microchip No.</span>
                <el-form-item
                  :ref="`pet_info.${index}.microchip_no`"
                  :rules="extraRules.pet_input"
                  :prop="`pet_info.${index}.microchip_no`"
                >
                  <v-input
                    v-model="item.microchip_no"
                    key-non-chinese
                    uppercase
                  />
                </el-form-item>
              </div>
              <div class="form-item form-half">
                <span>Date of Birth</span>
                <el-form-item
                  :ref="`pet_info.${index}.dob`"
                  :rules="extraRules.pet_input"
                  :prop="`pet_info.${index}.dob`">
                  <v-birth-day
                    v-model="item.dob"
                    :has-day="false" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Gender</span>
                <el-form-item
                  :ref="`pet_info.${index}.sex`"
                  :rules="extraRules.pet_select"
                  :prop="`pet_info.${index}.sex`"
                >
                  <v-select
                    v-model="item.sex"
                    :list="localAllOptions.sex_of_pet"
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Neuter</span>
                <el-form-item
                  :ref="`pet_info.${index}.is_neuter`"
                  :rules="extraRules.pet_select"
                  :prop="`pet_info.${index}.is_neuter`"
                >
                  <v-radio-group
                    v-model="item.is_neuter"
                    block
                    :list="yesNoOptions"
                  />
                </el-form-item>
              </div>
              <div class="form-item form-half">
                <span>Date of Last Mixed Vaccination</span>
                <el-form-item
                  :ref="`pet_info.${index}.last_vaccination_date`"
                  :rules="extraRules.pet_input"
                  :prop="`pet_info.${index}.last_vaccination_date`">
                  <v-birth-day
                    v-model="item.last_vaccination_date"
                    :has-day="false" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Is Physical Address of the Pet different from Corresponding Address in Hong Kong?</span>
                <el-form-item
                  :ref="`pet_info.${index}.is_diff_pet_addr`"
                  :rules="extraRules.pet_select"
                  :prop="`pet_info.${index}.is_diff_pet_addr`"
                >
                  <v-radio-group
                    v-model="item.is_diff_pet_addr"
                    block
                    :list="yesNoOptions"
                    @change="handleChange"
                  />
                </el-form-item>
              </div>

              <pet-address-form
                v-if="item.is_diff_pet_addr==1"
                :ref="'pet-address-form-'+index"
                :form="item"
                :street.sync="item.addr_street"
                :build.sync="item.addr_building"
                :room.sync="item.addr_room"
                :floor.sync="item.addr_floor"
                :block.sync="item.addr_block"
                :area.sync="item.addr_area"
                :district.sync="item.addr_district"
                :region.sync="item.addr_region"
                class="form-half"
                @getFormData="getSubFormData"></pet-address-form>
            </div>
          </div>
        </div>

        <div class="box">
          <h2>Upload Document</h2>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Policyholder HKID</span>
              <el-form-item
                ref="id_type_pic_path_id"
                prop="id_type_pic_path_id">
                <v-upload
                  :card="true"
                  ::disabled="isCancel||showBuyable||checkDisabled(['id_no','id_type'])"
                  :fileData="formData.id_type_pic"
                  :otherData="{
                    target: 'id_type_pic',
                    idKey: 'id_type_pic_path_id',
                    nameKey: 'id_type_pic_path',
                  }"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
              </el-form-item>
            </div>
          </div>
          <!--          <div class="flex-sb">-->
          <!--            <div-->
          <!--              v-for="(item, index) in formData.nm_pa_list"-->
          <!--              v-show="!(index == 0 && disabledHldrPa)"-->
          <!--              :key="'pa-document-form-' + index"-->
          <!--              class=" form-half">-->
          <!--              &lt;!&ndash;              <div class="document-title">&ndash;&gt;-->
          <!--              &lt;!&ndash;                <span class="label">Insured {{index+1}}</span>&ndash;&gt;-->
          <!--              &lt;!&ndash;              </div>&ndash;&gt;-->
          <!--              <div class="form-item">-->
          <!--                <span>Insured {{index+1}} HKID/Passport</span>-->
          <!--                <el-form-item-->
          <!--                  :ref="`id_type_pic${index}`"-->
          <!--                  v-model="item.id_type_pic"-->
          <!--                  :name="`id_type_pic${index}`">-->
          <!--                  <v-upload-->
          <!--                    :card="true"-->
          <!--                    ::disabled="isCancel||showBuyable"-->
          <!--                    :fileData="item.id_type_pic"-->
          <!--                    :otherData="{-->
          <!--                      target: 'id_type_pic',-->
          <!--                      idKey: 'id_type_pic_path_id',-->
          <!--                      index,-->
          <!--                      nameKey: 'id_type_pic_path',-->
          <!--                      type:'pa'-->
          <!--                    }"-->
          <!--                    @delete="handlerDeleteFile"-->
          <!--                    @uploadSuccess="handlerUploadSuccess"-->
          <!--                  />-->
          <!--                </el-form-item>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>

      </el-form>
    </lazy-dom>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import AddressForm from '@/views/components/address-form'
import VAreaInput from '@/components/control/v-area-input'
import PetAddressForm from '@/views/quoting/modules/pet/form/pet-address-form'
export default {
  name: 'PetPolicyForm',
  components: {
    PetAddressForm,
    AddressForm,
  },
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props: {
    form: {
      type: Object,
      default: null
    },
    occData: {
      type: Object,
      default: () => ({})
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    editQuote:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkBirth3 = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.formData
      const birth = dayjs(pcy_cmnt_dt).format('YYYY-MM-DD') || ( Date.now() + 1000 * 60 * 60 * 24)
      let msTime = new Date(value).getTime()
      let above18 = dayjs(value).add(18, 'year').format('YYYY-MM-DD')
      // if(msTime > Date.now()) {
      //   callback( new Error( '出生日期不得大於當前日期' ) )
      // }
      if(new Date(above18).getTime() > new Date(birth).getTime()) {
        callback( new Error('申請人必須年滿18歲' ) )
      }
      callback()
    }
    const checkPetInput = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const name = field_arr[2]
      const { pet_info } = this.formData||{}
      const text = pet_info[index][name]
      const valueResult = text !== null && text !== ''
      if(!valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkPetSelect = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const name = field_arr[2]
      const { pet_info } =  this.formData||{}
      const text = pet_info[index][name]
      const valueResult = text !== null && text !== ''
      if(!valueResult) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    return {
      checked:true,
      formData: {
        benefits:[],
        no_of_pet:'',
        class_id: '',
        isrd_title: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        mobile_no: '',
        email: '',
        isrd_dob: '',
        isrd_dob_date: '',
        id_no: '',
        pcy_cmnt_dt: '',
        // pcy_expry_dt: '',

        id_type_pic_path: '',
        id_type_pic_path_id: '',
        id_type:1,
        other_file: [],
        id_type_pic: {},

        pet_info:[
          {
            type_of_pet:'',
            breed_id:'',
            dob:'',
            colour_marking:'',
            microchip_no:'',
            sex:'',
            is_neuter:'',
            last_vaccination_date:'',
            is_diff_pet_addr:'',
            addr_area:'',
            addr_block:'',
            addr_building:'',
            addr_district:'',
            addr_floor:'',
            addr_region:'',
            addr_room:'',
            addr_street:'',
          }
        ]
      },
      formDataLock: 0,
      otherData: {},
      subForm: {
        'address-form': false,
      },
      addressForm: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      extraRules: {
        isrd_dob:[
          { validator: checkBirth3, trigger: ['blur'] }
        ],
        rel_id: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        title: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        lst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        fst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        dob: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_type: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        occ_id: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        pet_input:[
          { validator: checkPetInput, trigger: ['blur'] }
        ],
        pet_select:[
          { validator: checkPetSelect, trigger: ['blur'] }
        ]
      },
    }
  },
  computed: {
    pet_info(){
      let {pet_info} = this.formData||{}
      return pet_info||[]
    },
    localAllOptions() {
      return this.allOptions31
    },
    insuredItems(){
      let {benefits=[]} = this.allOptions31
      return benefits||[]
    },
    endDate(){
      let {pcy_expry_dt,pcy_period,ins_end_dt}  =this.form
      let {pcy_cmnt_dt=''}  =this.formData
      let date = ''
      if(pcy_period==0)
        date = pcy_expry_dt
      else
        date=pcy_cmnt_dt? dayjs(pcy_cmnt_dt).add(pcy_period,'month').subtract(1,'day').format('YYYY-MM-DD'):''
      if(this.isEndorsement)
        return  ins_end_dt?ins_end_dt:pcy_expry_dt

      this.formData.pcy_expry_dt = date
      return date
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })

      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        // })
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
      // return this.rules
    },
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      if(this.editQuote){
        arr = JSON.parse(JSON.stringify(this[`allOptions${this.formData.class_id}`].benefits))
      }else{
        kyc_benefit.some(item=>{
          // if(item.is_selected==1)
          //   this.formData.benefits.push(item.id)
          if(item.is_show!==0){
            arr.push({name:item.name,id:item.id})
          }
        })
      }
      return arr||[]
    },
    breedList(){
      return (type_of_pet)=>{
        let {cat_breeds,dog_breeds } = this.localAllOptions||{}
        if(type_of_pet==1){
          return cat_breeds||[]
        }
        else {
          return dog_breeds||[]
        }
      }
    },
    petInfoDefault(){
      return {
        type_of_pet:'',
        breed_id:'',
        dob:'',
        colour_marking:'',
        microchip_no:'',
        sex:'',
        is_neuter:'',
        last_vaccination_date:'',
        is_diff_pet_addr:'',
        addr_area:'',
        addr_block:'',
        addr_building:'',
        addr_district:'',
        addr_floor:'',
        addr_region:'',
        addr_room:'',
        addr_street:'',
      }
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          const formValue = JSON.parse(JSON.stringify(val))
          this.formData = Object.assign(
            this.formData,
            formValue
          )
          let {quote_coverage_list,pet_info} = val||{}
          let {kyc_benefit=[]} = quote_coverage_list||{}
          if(kyc_benefit)
          {
            kyc_benefit.some(item=>{
              if(item.is_selected==1)
                this.formData.benefits.push(item.id)
            })
            this.formData.benefits= [...new Set( this.formData.benefits)]
          }
          if(formValue.id_type_pic) {
            const { path, id } = val.id_type_pic
            this.formData.id_type_pic_path = path
            this.formData.id_type_pic_path_id = id
          }
          let pet_form_obj = {}
          let pet_list=  pet_info||[]
          pet_list.filter((item,index)=>{
            pet_form_obj[`pet-address-form-${index}`] = false
            this.formData.pet_info[index] = {...this.petInfoDefault,...item}
          })
          this.subForm = {
            ...this.subForm,
            ...pet_form_obj
          }
          this.handler().handlerAddress(formValue)
        }
      }
    },
    occData: {
      immediate: true,
      handler(val) {
        let {cust_typ} = this.form
        let keys = {
          isrd_title: '',
          isrd_lst_nm: '',
          isrd_dob: '',
          isrd_fst_nm: '',
          id_type: '',
          id_no: '',
          mobile_no: '',
          email: '',
          isrd_dob_date: '',
        }
        if (val) {
          Object.keys(keys).some(key => {
            if (key in val) {
              if(val[key])
                this.formData[key] = val[key]
            }
          })
        }
        if(val.phone)
          this.formData.mobile_no = val.phone
      }
    }
  },
  methods: {
    handleChange(){
      let {pet_info} = this.formData||{}
      let pet = JSON.parse(JSON.stringify(pet_info))
      this.formData.pet_info = []
      this.formData.pet_info = pet
    },
    handlerExtra(){
      let {extra_benefits,pcy_cmnt_dt,benefits} = this.formData
      let params = {
        extra_benefits,
        pcy_cmnt_dt,
        benefits
      }
      this.$emit('changeCompute',params)
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      if(typeof(field) != 'string'){
        let res = false
        field.map(item => {
          if(disable_filed.includes(item)){
            res = true
          }
        })
        return res
      }
      return disable_filed.includes(field)&&!!this.form[field]
    },
    getAddressForm(form, data) {
      // debugger
      this.subForm[form] = true
      this.formData = Object.assign(this.formData, data)
    },
    submitForm(otherData = {}) {
      let subForm = this.subForm
      let {pet_info} = this.formData||{}
      pet_info.filter((item,index)=>{
        let {is_diff_pet_addr} = item||{}
        if(is_diff_pet_addr!=1){
          delete subForm[`pet-address-form-${index}`]
        }
      })
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          Object.keys(subForm).some(key => {
            this.subForm[key] = false
            if(key.indexOf('pet-address-form-')!=-1){
              this.$refs[key][0].submitForm(key)
            }
            else
              this.$refs[key].submitForm(key)
          })
          if (Object.values(subForm).some(item => item === false)) {
            return
          }
          let {benefits=[]} = this.formData||{}
          const uniqueArray = benefits.filter((value, index, self) => {
            return self.indexOf(value) === index
          })
          const result = {
            ...this.formData,
            benefits:uniqueArray
          }
          this.$emit('getFormData', result, otherData)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },
    getSaveSubmitForm(otherData = {}){
      this.otherData = otherData
      let subForm = this.subForm
      let {pet_info} = this.formData||{}

      pet_info.filter((item,index)=>{
        let {is_diff_pet_addr} = item||{}
        if(is_diff_pet_addr!=1){
          delete subForm[`pet-address-form-${index}`]
        }
      })
      Object.keys(subForm).some(key => {
        this.subForm[key] = false
        if(key.indexOf('pet-address-form-')!=-1){
          this.$refs[key][0].submitFormNoVaild(key)
        }
        else
          this.$refs[key].submitFormNoVaild(key)
      })
      let {benefits=[]} = this.formData||{}
      const uniqueArray = benefits.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
      const result = {
        ...this.formData,
        benefits:uniqueArray
      }
      this.$emit('getFormData', result, otherData)
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path } = data

      this.$set(this.formData, idKey, id)
      this.$set(this.formData, 'id_type_pic', data)
      this.$set(this.formData, nameKey, path)
      // this.$set(this.formData, target, data)
      this.$refs['form'].validateField(idKey)
    },
    handlerDeleteFile({otherData}) {
      const { type, index } = otherData
      this.$set(this.formData, 'id_type_pic_path_id', '')
      this.$set(this.formData, 'id_type_pic', {})

    },
    handler() {
      return {
        handlerAddress: (data) => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region,
          } = data
          const obj = {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          }
          const params = {}
          Object.keys(this.addressForm).some(key => {
            params[key] = data[key]
          })

          this.formDataLock += 1
          this.addressForm = JSON.parse(JSON.stringify(obj))
        },
        handlerAddressResult: data => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const params = {
            office_addr_room: addr_room,
            office_addr_floor: addr_floor,
            office_addr_block: addr_block,
            office_addr_building: addr_building,
            office_addr_street: addr_street,
            office_addr_district: addr_district,
            office_addr_area: addr_area,
            office_addr_region: addr_region
          }
          Object.assign(this.formData, params)
        }
      }
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.formData = Object.assign(this.formData, data)
    },
    changeInsured() {
      const {
        id_no, id_type, isrd_dob, isrd_fst_nm, isrd_lst_nm, isrd_title, occ_id,hldr_is_pa_ind,
        id_type_pic
      } = this.formData||{}

      const { id, path } = id_type_pic || {}
      // 避免二次觸發 form 數據更新，影響 document 組件 司機數據
      if(hldr_is_pa_ind == 1) {

        Object.assign(this.formData.nm_pa_list[0], {
          rel_id: 1,
          dob: isrd_dob,
          fst_nm: isrd_fst_nm,
          id_no: id_no,
          id_type: id_type,
          lst_nm: isrd_lst_nm,
          occ_id: occ_id,
          title: isrd_title,
          id_type_pic_path_id: id,
          id_type_pic_path: path,
          id_type_pic: id_type_pic,
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.option_checkout{
  ::v-deep .el-checkbox-group{
    flex-direction: column;
    align-items: flex-start;
  }
}
.document-title {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: #677FA1;
  .label {
    padding-right: 8px;
    font-weight: 500;
    color: #000;
    white-space: nowrap;
  }
}
.pet-box{
  border-top: 1px solid #D1D5DA;
  padding-top: 30px;
  margin-top: 14px;
  .pet-title{
    font-size: 16px;
    font-weight: 600;
    display: block;
    margin-bottom: 20px;
  }
  .pet-card{
    border: 1px solid #D1D5DA;
    padding: 20px;
    border-radius: 6px;
    margin-bottom: 20px;
  }
 }

</style>
